module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T12-24-54.997Z.ebc520c9.png";